import { useQuery } from '@tanstack/react-query';
import apiService from '../services/api';
import { Component } from '../types';

export const useComponents = (categoryId: string) => {
  return useQuery<Component[]>({
    queryKey: ['components', categoryId],
    queryFn: () => apiService.getComponentsByCategory(categoryId),
    enabled: Boolean(categoryId),
    staleTime: 5 * 60 * 1000,
    select: (data: Component[]) => data.sort((a: Component, b: Component) => (a.blu_sortnumber ?? 0) - (b.blu_sortnumber ?? 0)),
  });
}; 